export default __webpack_public_path__ + "static/media/Icon13.10f1ad9b.svg";